import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Admin from "./pages/Admin/Admin";
import Help from "./pages/Help/Help";
import Home from "./pages/Home/Home";
import Login from "./pages/Login/Login";
import Tag from "./pages/Tag/Tag";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/tag/:uid" element={<Tag />} />
        <Route path="/help" element={<Help />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </Router>
  );
}

export default App;
